import { Box, Button } from '@mui/material';
import { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { formatDayLabel } from '../../../library/dateTimeHelper';
import {
    dayHeaderGutterStyles,
    dayHeaderRowStyles,
    dayHeaderStyles,
} from './myCalendar.styles';

interface DayHeaderRowProps {
    /** The week's seven dates, in the order their columns are drawn. */
    days: string[];
    today: string;
    /** The way from a day's name into that day on its own. */
    onPickDay: (day: string) => void;
}

/**
 * The weekday names above the week grid's columns.
 *
 * Its own component, and not part of `ScheduleGrid`, because it is the one piece of the
 * grid that has to stay on screen while the rest of it scrolls past -- so the page mounts
 * it inside the sticky rail rather than in the grid's own flow. It still shares the
 * grid's column template, which is what keeps a name over its column.
 */
export const DayHeaderRow = ({ days, today, onPickDay }: DayHeaderRowProps): JSX.Element => {
    const { i18n } = useTranslation();

    return (
        <Box sx={dayHeaderRowStyles(days.length)}>
            <Box sx={dayHeaderGutterStyles} />

            {days.map(day => (
                <Button
                    key={day}
                    size="small"
                    data-testid="my-calendar-day-header"
                    data-day={day}
                    sx={dayHeaderStyles(day === today)}
                    onClick={() => onPickDay(day)}
                >
                    {formatDayLabel(day, i18n)}
                </Button>
            ))}
        </Box>
    );
};
